module.exports = __webpack_public_path__ + "static/exhibitors-background-colored-exhibitors-mob.d29f7115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/exhibitors-background-colored-exhibitors-mob.jpg
// module id = 986
// module chunks = 101932004231744